// extracted by mini-css-extract-plugin
export default {"input-block-root":"InputBlock_input-block-root__TVO-B","block":"InputBlock_block__V+LHo","sm":"InputBlock_sm__SjPFP","label":"InputBlock_label__0o3-V"};